<template>
  <div>
    <template v-if="batteries.length > 0">
      <BTable striped
              no-border-collapse
              sticky-header="300px"
              :empty-text="tr('javascript.TX_NO_ENTRIES')"
              :show-empty="true"
              :fields="fields"
              :items="batteries"
              :sort-direction="TableSortDirection.DEFAULT">
        <template #head(action)>
          {{ tr('javascript.TX_ACTION') }}
        </template>
        <template #head(battery)>
          {{ tr('portal.TX_BATTERY') }}
        </template>
        <template #head(measurement)>
          {{ tr('default.TX_MESSWERT') }}
        </template>
        <template #cell(action)="{ item: battery }">
          <BFormCheckbox v-if="battery.type !== null"
                         v-model="selectedBatteryIds[battery.id]"
                         name="check-button"
                         switch
                         @change="onSwitch(battery, $event)"></BFormCheckbox>
        </template>
        <template #cell(battery)="row">
          {{ row.item.name }}
        </template>
        <template #cell(measurement)="row">
          <template v-if="row.item.type === null">
            {{ tr('administration.powerFlow.NO_BATTERY_MEASUREMENT') }}
          </template>
          <template v-else-if="row.item.type === 'AC_DC'">
            {{ tr('administration.powerFlow.BATTERY_POWER') }} AC {{ `(BAT(${row.item.serial})-B_P_AC)` }},
            {{ tr('administration.powerFlow.BATTERY_POWER') }} DC {{ `(BAT(${row.item.serial})-B_P_DC)` }}
          </template>
          <template v-else>
            {{ tr('administration.powerFlow.BATTERY_POWER') }} {{ row.item.type }} {{ `'BAT(${row.item.serial})-B_P_${row.item.type}'` }}
          </template>
        </template>
        <template #empty="scope">
          {{ scope.emptyText }}
        </template>
      </BTable>
    </template>
  </div>
</template>

<script>
  import { BTable, BFormCheckbox } from 'bootstrap-vue';
  import { translator } from '~/zf/frontend/common/mixins';
  import TableSortDirection from '../../../../vendor/bootstrap-vue/TableSortDirection';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import BatteryCurrentType from '../const/BatteryCurrentType';

  export default {
    name: 'BatteryConfig',
    compatConfig: {
      MODE: 3,
    },
    components: {
      BTable, BFormCheckbox,
    },
    mixins: [
      translator,
    ],
    props: {
      batteries: {
        type: Array,
        required: true,
      },
      initialSelectedBatteryIds: {
        type: Array,
        default: () => [],
      },
    },
    emits: ['mixed-battery-currents-selected', 'battery-enabled-changed'],
    data() {
      return {
        selectedBatteryIds: {},
        fields: ['action', 'battery', 'measurement'],
        TableSortDirection,
        BootstrapVariant,
      };
    },
    computed: {
      selectedBatteries() {
        return this.batteries.filter((battery) => this.selectedBatteryIds[battery.id]);
      },
    },
    mounted() {
      if (this.initialSelectedBatteryIds) {
        this.selectedBatteryIds = this.initialSelectedBatteryIds.reduce((accumulator, current) => {
          accumulator[current] = true;
          return accumulator;
        }, {});
      }
    },
    methods: {
      onSwitch(battery, isEnabled) {
        if (isEnabled && battery.type !== BatteryCurrentType.AC_DC) {
          const otherSelectedBatteryCurrentType = this.selectedBatteries.filter(
            (otherBattery) => otherBattery.id !== battery.id
              && otherBattery.type !== BatteryCurrentType.AC_DC,
            // There can only be one current type anyway (except `AC_DC` batteries, which are ignored)
          )[0]?.type;
          if (otherSelectedBatteryCurrentType && battery.type !== otherSelectedBatteryCurrentType) {
            this.selectedBatteryIds = { ...this.selectedBatteryIds, [battery.id]: false };
            this.$emit('mixed-battery-currents-selected');
            return;
          }
        }
        this.$emit(
          'battery-enabled-changed',
          this.filterSelectedBatteries(this.selectedBatteryIds),
        );
      },
      filterSelectedBatteries(batteries) {
        return Object.entries(batteries)
          .filter((battery) => battery[1] === true)
          .map((battery) => battery[0]);
      },
    },
  };
</script>
